import { styled } from "@mui/material/styles";

export const Container = styled("div")(({ theme }) => ({
display: "flex",
  justifyContent: "space-between",
  border: "1px solid transparent",
  borderRadius: "8px",
  backgroundImage: "linear-gradient(#030039, #030039), linear-gradient(to left, #962EFF, #01ECFF)",
  backgroundOrigin: "border-box",
  backgroundClip: "padding-box, border-box",
  padding: "12px",
  alignItems: "center",
  "& .logo": {
    "& img": {
      width: "67px"
    }
  },
  "& .utils": {
    "& ul": {
      display: "flex",
      listStyle: "none",
      margin: 0,
      gap: "10px",
      "& li": {
        "& button": {
          background: "transparent",
          border: 0,
          cursor: "pointer",
        },
      },
    },
  },
}));
